import {
  extractReaderCharacters,
  extractReaderGrammarConceptIds,
  extractReaderWordIds
} from '@/lib/familiarity-core'
import {
  characterLearningLocator,
  grammarLearningLocator,
  wordLearningLocator
} from '@/lib/learning-state-core'
import { upsertPassiveLearningContentStates } from '@/lib/learning-state'
import type { ReaderContent } from '@/types/reader'

export function getReaderExposure(content: ReaderContent) {
  return {
    wordIds: extractReaderWordIds(content),
    characters: extractReaderCharacters(content),
    grammarConceptIds: extractReaderGrammarConceptIds(content)
  }
}

export async function recordReaderExposure({
  userId,
  content,
  storyStatus = 'seen'
}: {
  userId: string
  content: ReaderContent
  storyStatus?: 'seen' | 'studying' | 'completed'
}) {
  const exposure = getReaderExposure(content)
  const sourceMetadata = {
    sourceType: content.sourceType,
    source_type: content.sourceType,
    contentId: content.id,
    content_id: content.id,
    title: content.title
  }
  const storySlug =
    content.sourceType === 'story' ? (content.metadata?.slug ?? null) : null

  await upsertPassiveLearningContentStates({
    userId,
    items: [
      ...(storySlug
        ? [
            {
              ...{ contentType: 'story' as const, contentId: storySlug },
              status: storyStatus,
              progress: storyStatus === 'completed' ? 1 : undefined,
              metadata: sourceMetadata
            }
          ]
        : []),
      ...exposure.wordIds.map((id) => ({
        ...wordLearningLocator(id),
        status: 'seen' as const,
        metadata: sourceMetadata
      })),
      ...exposure.characters.map((character) => ({
        ...characterLearningLocator(character),
        status: 'seen' as const,
        metadata: sourceMetadata
      })),
      ...exposure.grammarConceptIds.map((conceptId) => ({
        ...grammarLearningLocator(conceptId),
        status: 'seen' as const,
        metadata: sourceMetadata
      }))
    ]
  })
}
